import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '处理步骤',
    type: 'BDLOGIC_TARGET',
}
